export default __webpack_public_path__ + "static/media/YUAN400.72049015.pdf";